import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { CadastroComponent } from 'src/app/user/cadastro/cadastro.component';
import { LoginComponent } from 'src/app/user/login/login.component';
import { ResumoClientComponent } from 'src/app/client/resumo-client/resumo-client.component';
import { HorariosService } from 'src/app/services/horarios.service';
import { ConvenioClientComponent } from 'src/app/client/convenio-client/convenio-client.component';
import { ProcedimentoClientComponent } from 'src/app/client/procedimento-client/procedimento-client.component';
import { MatDialog, MatHorizontalStepper } from '@angular/material';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HorariosClientComponent } from '../../horarios-client/horarios-client.component';
import { AgendasService } from 'src/app/services/agendas.service';
import { ParametrosService } from 'src/app/services/parametros.service';
import { ConveniosService } from 'src/app/services/convenios.service';
import { ProcedimentosService } from 'src/app/services/procedimentos.service';
import { StatusAgendamentoService } from 'src/app/services/status-agendamento.service';
import { DialogPesoComponent } from '../../dialog-peso/dialog-peso.component';
import { RequestingPhysicianService } from 'src/app/services/requesting-physician.service';

interface Response extends Array<any> { }

@Component({
  selector: 'app-agendamento-login-primeiro',
  templateUrl: './agendamento-login-primeiro.component.html',
  styleUrls: ['./agendamento-login-primeiro.component.scss']
})
export class AgendamentoLoginPrimeiroComponent implements OnInit {
  @ViewChild(ConvenioClientComponent) convenioChild: ConvenioClientComponent;
  @ViewChild(ProcedimentoClientComponent) procedimentoChild: ProcedimentoClientComponent;
  @ViewChild(ResumoClientComponent) resumoChild: ResumoClientComponent;
  @ViewChild(HorariosClientComponent) horarioChild: HorariosClientComponent;
  @ViewChild(LoginComponent) loginChild: LoginComponent;
  @ViewChild(CadastroComponent) cadastroChild: CadastroComponent;
  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;
  horarios: any;
  horarioSel: any;
  filteredHorarios: any
  agendaNomes: string[] = []
  Agendas: any[]
  tipo = 2;
  procedimentos: any = [];
  procedimentoSel: any;
  sessionData: any = {};
  // Inicialização de função homônima ao EventEmitter de horarios-cliente, para eliminar ng warning
  horarioSelecionado: any;
  modoCadastro: boolean;
  alteraModoCadastro: any;
  smallScreen: boolean;
  carregandoHorarios: boolean;
  camposValidos: boolean;
  agendas: any;
  servicos: any;
  tipoAgendamento: string;
  feriados: any;
  company: any;
  requestingPhysicians: any[]
  selectedPhysician: any

  steps: any = {
    convenio: { completed: false },
    procedimento: { completed: false },
    horario: { completed: false },
    login: { completed: true },
    pagamento: { completed: false },
    resumo: { completed: false }
  }

  isLoader = false

  constructor(
    private horariosService: HorariosService,
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private agendaService: AgendasService,
    private parametros: ParametrosService,
    private convenioService: ConveniosService,
    private procedimentosService: ProcedimentosService,
    private statusAgendamentoService: StatusAgendamentoService,
    private dialog: MatDialog,
    private requestingPhysicianService: RequestingPhysicianService
  ) {
    this.modoCadastro = false;
    this.camposValidos = false;
    this.authService.userLoggedOut.subscribe(userLoggedOut => {
      // Se usuário fez logout usando ícone no menu na barra, atualiza sessionData
      if (userLoggedOut) {
        this.updateSessionData();
        this.stepper.selectedIndex = 0;
        
      }
    });

    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });

    this.onLoadAgendas();
    const type = this.parametros.getParams('APP_TYPE');
    this.tipoAgendamento = type.valor;

    this.procedimentoSel = {
      descricao: ''
    };

    this.parametros.loadFeriados()
      .subscribe((resp: any) => {
        this.feriados = resp;
      });
  }


  onStepChange = (event) => {
    if (event.selectedStep.label === 'stepHorario') {
      if (this.convenioService.convenioParametros) {
        this.horarioChild.validarCarteirinhaValidade = this.convenioService.convenioParametros.parametroValidarCarteirinhaValidade
      }
    }

    if (event.selectedStep.label ===  'stepResumo' || event.selectedStep.label ===  'stepResumo' ) {
      this.isLoader = true
      const user = this.authService.getUser()
      const param = this.convenioService.findConvenioParametros(this.sessionData.selecaoObj.convenio.integracao_id, this.sessionData.selecaoObj.plano.integracao_id || null)

      if (param && param.hasOwnProperty('CategoriaPlanoParametrosIntegr') && param.CategoriaPlanoParametrosIntegr && param.CategoriaPlanoParametrosIntegr === 3) {
        this.convenioService.checkEloCPF(user.cpf)
          .subscribe(resp => {
            if (resp && resp.codigo === 1) {
              this.isLoader = false
              this.statusAgendamentoService.setStepStatus(event);
            } else {
              alert('Paciente não credenciado para o convênio')
              sessionStorage.removeItem('selecaoObj');
              sessionStorage.removeItem('horarioSel');
              this.horarioSel = null;
              this.updateSessionData()
              this.stepper.selectedIndex = 0
              this.isLoader = false
            }
          })
      } else {
        this.isLoader = false
        this.statusAgendamentoService.setStepStatus(event);
      }
    } else {
      this.statusAgendamentoService.setStepStatus(event);
    }
  }

  ngOnInit() {
    this.horarios = [];
    this.getUserData()
    this.requestingPhysicianService.getRequestingPhysicians({columns: "ProfMedSolicitanteID, pessoa.PessoaNome"}).subscribe((resp) => {
      this.requestingPhysicians = resp.data
    })
  }

  convenioValida($event: any) {
    this.camposValidos = $event;
  }

  procedimentoValida($event: any) {
    this.camposValidos = $event;
    this.agendaNomes = []
  }

  filterAgendasByAgenda(agendaNome: string){
    if (!agendaNome) {
      this.filteredHorarios = this.horarios
      return
    }
    this.filteredHorarios = this.horarios.filter((dia) => dia.agendas[0].agendaNome === agendaNome)
  }

  selecaoValida() {
    this.updateSessionData();

    const { myConvenioControl, myPlanoControl, myEspecialidadeControl,
      planosConvenio } = this.convenioChild;

    if (myConvenioControl.status === 'VALID' &&
      ((myPlanoControl.status === 'VALID' && planosConvenio.length > 0) || (planosConvenio.length === 0)) &&
      myEspecialidadeControl.status === 'VALID') {
      this.consultaHorarios();
      this.stepper.next();
    } else {
      myConvenioControl.markAsTouched({ onlySelf: true });
      myPlanoControl.markAsTouched({ onlySelf: true });
      myEspecialidadeControl.markAsTouched({ onlySelf: true });
    }
  }

  consultaHorarios() {
    this.company = this.parametros.getParams('APP_COMPANY');
    this.horarios = [];
    this.carregandoHorarios = true;
    const { convenioSelecionado, planoSelecionado, especialidadeSelecionada
    } = this.convenioChild;
    let procedimentoSelecionado: any = {};
    if (this.procedimentoChild !== undefined) {
      procedimentoSelecionado = this.procedimentoChild.procedimentoSelecionado;
      this.procedimentoSel = procedimentoSelecionado;
    }

    const { selectedRequestingPhysicians } = this.procedimentoChild

    let sucederHoras = 0
    if (this.procedimentoSel.suceder_dias) {
      sucederHoras += this.procedimentoSel.suceder_dias * 24
    }
    sucederHoras += this.procedimentoSel.suceder_horas

    // Armazena seleção do usuário na session
    const selecaoObj = {
      convenio: convenioSelecionado,
      plano: planoSelecionado,
      especialidade: especialidadeSelecionada,
      procedimento: procedimentoSelecionado,
      dataInicial: this.horarioChild.date,
      requestingPhysicianId: selectedRequestingPhysicians
    };
    sessionStorage.setItem('selecaoObj', JSON.stringify(selecaoObj));

    const agendasDisponivel = [];
    const examesDisponivel = [];

    // Parametros do Otimus, configagenda (Para ver se é necessario validar o convenio)
    const configagenda = this.parametros.getParamsAgendamento();
    const convenioServices = this.convenioService.getConveniosServicos();

    this.agendas.forEach((ag: any) => {
      let agendaValid = true;

      // Se for necessário validar o convenio por agenda
      if (configagenda.valida_convenio) {
        const convObj = ag.convenios.find((conv: any) => conv.id === convenioSelecionado.id);
        if (!convObj) {
          agendaValid = false;
        }
      }

      // Se não for necessário, ainda tem de validar se o convênio atende os procedimentos
      if (ag.procedimentos) {
        // Id integração do procedimento, se app_tipo for 'consulta', considera apenas 1o procedimento
        const procIntId = this.tipoAgendamento === 'CONSULTA'
          ? ag.procedimentos[0].integracao_id
          : procedimentoSelecionado.procedimento_integracao_id;

        const convObj = convenioServices.find((conv: any) =>
          conv.convenio_id === convenioSelecionado.integracao_id
          && conv.servico_id === procIntId
        );

        if (!convObj) {
          agendaValid = false;
        }
      } else {
        agendaValid = false;
      }

      if (ag.hasOwnProperty('especialidades')) {
        const especObj: any = ag.especialidades.find(
          (esp: any) => esp === especialidadeSelecionada.id);

        if (!especObj) {
          agendaValid = false;
        }
      } else {
        agendaValid = false;
      }

      if (ag.procedimentos) {
        const atendeProc: any = ag.procedimentos.find((proc: any) =>
          proc.integracao_id === ag.procedimentos[0].integracao_id && this.tipoAgendamento === 'CONSULTA'
          || proc.integracao_id === procedimentoSelecionado.procedimento_integracao_id && this.tipoAgendamento !== 'CONSULTA'
        );

        if (!atendeProc) {
          agendaValid = false;
        }
      } else {
        agendaValid = false;
      }

      if (ag.status && ag.status === true) {
        // Continuar
      } else {
        agendaValid = false;
      }

      if (agendaValid === true) {
        if (ag.tipo_agenda === 'exames') {
          examesDisponivel.push(ag.integracao_id);
        } else {
          agendasDisponivel.push(ag.integracao_id);
        }
      }
    });

    this.horariosService.consultaHorarios(agendasDisponivel, selecaoObj, examesDisponivel, sucederHoras, this.procedimentoSel)
      .subscribe(data => {
        const newHorarios: any = data;
        if (newHorarios.length) {
          newHorarios.forEach((element: any) => {
            element.agendas.forEach((agenda) => {
              const agendaNome = agenda.agendaNome
              if(!this.agendaNomes.includes(agendaNome)){
                this.agendaNomes.push(agendaNome)
              }
            })
            let totalManha = 0;
            let totalTarde = 0;
            element.agendas.forEach(function (agElement: any, index) {
              agElement.horarios.forEach((hrElement: any) => {
                const hora: number = parseInt(hrElement.hora.substring(0, 2), 10);
                if (hora > 12) {
                  totalTarde += 1;
                } else {
                  totalManha += 1;
                }
              });
              this[index].horarios.sort(function (a, b) { if (a.hora < b.hora) { return -1; } });
            }, element.agendas);
            element.totalManha = totalManha;
            element.totalTarde = totalTarde;
            this.horarios.push(element);
          });

          const periodo = sessionStorage.getItem('horarios-periodo')
          if (periodo) {
            for (let horario of this.horarios) {
              for (let agenda of horario.agendas) {
                const newHorarios = []
                for (let innerHorario of agenda.horarios) {
                  const hora: number = parseInt(innerHorario.hora.split(':')[0]);

                  // console.log(index, ', hora: ', hora, ', condicao: ', periodo === 'manha' && hora > 12)
                  if (periodo === 'manha' && hora <= 12) {
                    newHorarios.push(innerHorario)
                  }
                  if (periodo === 'tarde' && hora > 12) {
                    newHorarios.push(innerHorario)
                  }
                  if (periodo === 'ambos') {
                    newHorarios.push(innerHorario)
                  }
                }
                agenda.horarios = newHorarios
              }
            }
          }

          this.filteredHorarios = this.horarios
          this.consultarValores();
          this.carregandoHorarios = false;
        } else {
          this.carregandoHorarios = false;
          this.horarios = [];
        }
      });
  }

  consultarValores() {
    const myCompany = this.company;
    const agendasList = JSON.parse(sessionStorage.getItem('agendas'));
    const myFeriados = this.feriados;

    this.horarios.forEach(element => {
      /*

        element.data  -- 18-12-2019

        e para substituir

        element.agendas.forEach(el) { el.valor = 1; }
      */
      const { convenioSelecionado, planoSelecionado } = this.convenioChild;
      const { procedimentoSelecionado } = this.procedimentoChild;
      const Data = element.data.replace(/-/g, '/');
      const { params } = this.parametros;
      const userObj = params.find((prm: any) => prm.chave === 'APP_USUARIO_ID');
      const hostObj = params.find((prm: any) => prm.chave === 'APP_OTIMUS_HOST');
      const valorQuery: any = {
        servicoID: procedimentoSelecionado.procedimento_integracao_id,
        ConvenioID: convenioSelecionado.integracao_id,
        ConvenioNome: planoSelecionado.integracao_id,
        host: hostObj && hostObj.valor,
        user: userObj && userObj.valor,
        Data
      };

      this.procedimentosService.consultaValor(valorQuery)
        .subscribe((resp: any) => {
          if (resp && resp.procedimentosJsonList) {
            const valorObj = resp.procedimentosJsonList[0];
            const valorStr = valorObj && valorObj.procedimentoNome;
            const valorTrim = valorStr ? valorStr.trim().replace('.', ',') : valorStr;

            element.agendas.forEach(function(el, index) {

              // VALIDACAO TEMPORARIO PARA SANTA VISITA  Só VALOR NA TELA
              let mudarLink: boolean;
              let agendaFds: boolean;
              mudarLink = false;
              agendaFds = false;

              const agId = el.agendaId;
              this[index].valor = valorTrim;
            }, element.agendas);
          }
        },
          err => console.error(err)
        );

    });
  }

  consultaProcedimentos() {

    const { convenioSelecionado, especialidadeSelecionada, planoSelecionado } = this.convenioChild;
    const agendasFiltradas = this.agendas.filter((ag: any) => {
      const atendeConvenio = ag.convenios && ag.convenios.find(
        (conv: any) => conv.id === convenioSelecionado.id
      );

      const atendeEspecialidade = ag.especialidades && ag.especialidades.find(
        (espec: any) => espec === especialidadeSelecionada.id
      );

      if (atendeConvenio && atendeEspecialidade) {
        return true;
      }
      return false;
    });

    const query = {
      agendas: agendasFiltradas,
      convenio: convenioSelecionado,
      plano: planoSelecionado && planoSelecionado.id ? planoSelecionado : null
    };

    this.procedimentosService.consultaProcedimentos(query)
      .subscribe((data: any) => {
        this.procedimentos = data.ativos;
        this.procedimentoChild.setFormControls();
      });
  }

  selecionaHorario = (data: any, agenda: any, hora: any) => {

    const myCompany = this.company;


    let count = 0;
    let temErro = false;
    const proximoPasso = (err: any) => {
      count += 1;
      if (err) {
        temErro = true;
        window.alert(err);
      }

      if (count === 2 && !temErro) {
        this.stepper.next();
      }
    };

    const trancaHorario = () => {
      // TODO: tratar erro trancamento
      const horarioObj = { data, agenda, hora };
      let continuar = true;
      this.horariosService.trancaHorario(horarioObj).subscribe(
        (response: Response[any]) => {
          if (
            !response.error ||
            (response.hasOwnPropertyhorarioslivresJsonList &&
              response.horarioslivresJsonList.length > 0)
          ) {
            const myAgendaSession: any = JSON.parse(
              sessionStorage.getItem("agendas")
            );
            const FndAgenda = myAgendaSession.find(
              (fnd: any) =>
                fnd.integracao_id.toString() ===
                  this.horarioSel.hora.agendaid.toString() &&
                fnd.tipo_agenda.toString() ===
                  this.horarioSel.hora.tipo
                    .replace("ag", "consulta")
                    .replace("cs", "exames")
                    .toString()
            );
            if (FndAgenda) {
              const FndProc = FndAgenda.procedimentos;
              sessionStorage.setItem("procedimentos", JSON.stringify(FndProc));
              this.horarioSel.hora.agenda_id = FndAgenda.id;
            }
            sessionStorage.setItem(
              "horarioSel",
              JSON.stringify(this.horarioSel)
            );
            // Chama EventEmitter do componente horarios-client
            this.updateSessionData();

            proximoPasso(null);
          } else {
            continuar = false;
            this.horarioSel = null;
            window.alert("Horário acaba de ser reservado por outro usuário.");
            this.consultaHorarios();
          }
        },
        (err) => proximoPasso(err)
      );

      if (continuar === true) {
        this.horarioSel = horarioObj;

        const { convenioSelecionado, planoSelecionado } = this.convenioChild;
        const procedimentoSelecionado =
          this.procedimentoChild &&
          this.procedimentoChild.hasOwnProperty("procedimentoSelecionado")
            ? this.procedimentoChild.procedimentoSelecionado
            : {};
        const Data = data.replace(/-/g, "/");
        const { params } = this.parametros;
        const userObj = params.find(
          (prm: any) => prm.chave === "APP_USUARIO_ID"
        );
        const hostObj = params.find(
          (prm: any) => prm.chave === "APP_OTIMUS_HOST"
        );

        const valorQuery: any = {
          servicoID: procedimentoSelecionado.procedimento_integracao_id,
          ConvenioID: convenioSelecionado.integracao_id,
          ConvenioNome: planoSelecionado.integracao_id,
          host: hostObj && hostObj.valor,
          user: userObj && userObj.valor,
          Data,
        };

        this.procedimentosService.consultaValor(valorQuery).subscribe(
          (resp: any) => {
            if (resp && resp.procedimentosJsonList) {
              const valorObj = resp.procedimentosJsonList[0];
              const valorStr = valorObj && valorObj.procedimentoNome;
              const valorTrim = valorStr.trim().replace(".", ",");

              // VALIDACAO TEMPORARIO PARA SANTA VISITA
              let mudarLink: boolean;
              let agendaFds: boolean;
              mudarLink = false;
              agendaFds = false;
              // if (myCompany.valor === 'Santa Visita') {

              //   if (hora.ProfMedId === 1
              //     || hora.ProfMedId === 19
              //     || hora.ProfMedId === 18
              //     || hora.ProfMedId === 20
              //   ) {
              //     agendaFds = true;
              //   }

              //   const dataSelect = data;
              //   const ano = dataSelect.substring(6, 10);
              //   const mes = dataSelect.substring(3, 5);
              //   const dia = dataSelect.substring(0, 2);
              //   const selectDay = new Date(ano, mes - 1, dia);
              //   const dow = selectDay.getDay();
              //   if (dow === 0 || dow === 6) {
              //     // FDS
              //     mudarLink = true;
              //   }

              //   // Verifica Feriado
              //   this.feriados.forEach(fer => {
              //     const ferAno = fer.FeriadosData.substring(0, 4);
              //     const ferMes = fer.FeriadosData.substring(5, 7);
              //     const ferDia = fer.FeriadosData.substring(8, 10);
              //     const newData = new Date(ferAno, ferMes - 1, ferDia);
              //     if (fer.FeriadosOcorrencia === 'N') {
              //       // Ano exato
              //       if (dia == ferDia && mes == ferMes && ano == ferAno) {
              //         mudarLink = true;
              //       }
              //     } else {
              //       // Apenas mes e dia
              //       if (dia == ferDia && mes == ferMes) {
              //         mudarLink = true;
              //       }
              //     }

              //   });

              // }

              // if (mudarLink === true && agendaFds === true) {
              //   this.horarioSel.valor = '300,00';
              //   this.horarioSel.procedimentoNome = procedimentoSelecionado.descricao;
              //   this.horarioSel.linkPagamento = 'https://www.asaas.com/c/929793659714';

              //   sessionStorage.setItem('horarioSel', JSON.stringify(this.horarioSel));
              //   this.updateSessionData();
              // } else {
              // FLUXO NORMAL DENTRO DO ELSE
              this.horarioSel.valor = valorTrim;
              this.horarioSel.procedimentoNome =
                procedimentoSelecionado.descricao;
              this.horarioSel.linkPagamento =
                procedimentoSelecionado.linkPagamento;

              sessionStorage.setItem(
                "horarioSel",
                JSON.stringify(this.horarioSel)
              );
              this.updateSessionData();
              // }
            }
            proximoPasso(null);
          },
          (err) => proximoPasso(err)
        );
      }
    };

    const agendasStr = sessionStorage.getItem("agendas");
    if (!agendasStr) return;
    const agendas = JSON.parse(agendasStr);

    const foundAgenda = agendas.find((val: any) => val.descricao === agenda);
    if (foundAgenda && foundAgenda.peso_suportado) {
      const dialogRef = this.dialog.open(DialogPesoComponent, {
        disableClose: true,
        data: { agendaSelecionada: agenda },
      });
      dialogRef.afterClosed().subscribe((isValid) => {
        if (isValid) trancaHorario();
      });
    } else {
      trancaHorario();
    }
  }

  // Função chamada pelo EventEmitter de horarios-client
  updateHorarioSelecionado() {

    this.updateSessionData();
  }

  updateUserLogged() {

    this.updateSessionData();
    this.modoCadastro = false;
  }

  updateSessionData() {
    const userData = sessionStorage.getItem('userData');
    const selecaoObj = sessionStorage.getItem('selecaoObj');
    const horarioSel = sessionStorage.getItem('horarioSel');

    this.sessionData = {
      userData: JSON.parse(userData),
      selecaoObj: JSON.parse(selecaoObj),
      horarioSel: JSON.parse(horarioSel)
    };
  }

  userLogOut() {
    sessionStorage.removeItem('userData');
    this.updateSessionData();
  }

  userRegister() {
    this.alteraModoCadastro.emit();
  }

  updateModoCadastro() {
    this.modoCadastro = !this.modoCadastro;
  }

  validarCamposPreenchidos() {
    if (this.convenioChild.myConvenioControl.status === 'VALID' &&
      ((this.convenioChild.myPlanoControl.status === 'VALID' && this.convenioChild.planosConvenio.length > 0)
        || (this.convenioChild.planosConvenio.length === 0))
      && this.convenioChild.myEspecialidadeControl.status === 'VALID') {
      return true;
    } else {
      return false;
    }
  }

  onLoadAgendas() {
    this.agendaService.consultaAgendas()
      .subscribe(data => {
        this.agendas = data;
        const agendasConsulta = [];
        const agendasExames = [];
        this.loadAgendasEspecialidades();
        this.agendas.forEach((element: any) => {
          if (element.tipo_agenda === 'consulta') {
            agendasConsulta.push(element.integracao_id);
          } else if (element.tipo_agenda === 'exames') {
            agendasExames.push(element.integracao_id);
          }
        });
        this.loadAgendasConvenios(agendasConsulta, agendasExames);
        this.loadAgendasProcedimentos();
      });
  }

  loadAgendasEspecialidades() {
    this.agendaService.consultaAgendasEspecialidades()
      .subscribe(data => {
        const myEspec: any = data;
        const myAgendas: any = this.agendas;
        myEspec.forEach((espec: any) => {
          const myIndex = myAgendas.findIndex((ag: any) => {
            return ag.id === espec.agenda_id;
          });
          if (myIndex >= 0) {
            if (!this.agendas[myIndex].especialidades) {
              this.agendas[myIndex].especialidades = [];
            }
            this.agendas[myIndex].especialidades.push(espec.especialidade_id);
          }
        });
        sessionStorage.setItem('agendas', JSON.stringify(this.agendas));
      });
  }

  loadAgendasConvenios(lAgendas: any, lExames: any) {
    const configagenda = this.parametros.getParamsAgendamento();
    if (configagenda.valida_convenio) {
      this.agendaService.consultaAgendasConvenios(lAgendas, lExames)
        .subscribe(data => {
          const myConv: any = data;
          const myAgendas: any = this.agendas;
          myConv.forEach((conv: any) => {
            let myIndex = -1;
            myIndex = myAgendas.findIndex((item: any) => {
              return item.integracao_id === conv.agenda_id;
            });
            if (myIndex >= 0) {
              if (!this.agendas[myIndex].convenios) {
                this.agendas[myIndex].convenios = [];
              }
              this.agendas[myIndex].convenios.push({
                id: conv.convenio_id,
                nome: conv.convenio_nome
              });
            }
          });
          sessionStorage.setItem('agendas', JSON.stringify(this.agendas));
        });
    } else {
      // Add Todos os convenios
      this.convenioService.consultaConvenios()
        .subscribe(data => {
          const myConvenios: any = data;

          for (let index = 0; index < this.agendas.length; index++) { // tslint:disable-line
            const element = this.agendas[index];
            if (!element.hasOwnProperty('convenios')) {
              this.agendas[index].convenios = [];
            }

            myConvenios.forEach((conv: any) => {
              this.agendas[index].convenios.push({
                id: conv.id,
                nome: conv.descricao
              });
            });


          } // ENDFOR
        });
    }
  }

  loadAgendasProcedimentos() {
    this.agendaService.consultaAgendaProcedimentos()
      .subscribe(data => {
        const myProcs: any = data;
        const myAgendas: any = this.agendas;

        myProcs.forEach((proc: any) => {
          let myIndex = -1;
          myIndex = myAgendas.findIndex((item: any) => {
            return item.id === proc.agenda_id;
          });
          if (myIndex >= 0) {
            if (!this.agendas[myIndex].procedimentos) {
              this.agendas[myIndex].procedimentos = [];
            }
            this.agendas[myIndex].procedimentos.push({
              id: proc.procedimento_id,
              nome: proc.procedimento_nome,
              integracao_id: proc.procedimento_integracao_id
            });
          }
        });
        sessionStorage.setItem('agendas', JSON.stringify(this.agendas));
      });
  }

  updateServicos(valor: any) {
    this.servicos = valor;
  };

  onCompleteStep = this.statusAgendamentoService.stepStatusChange.subscribe(value => {
    let label = value.selectedStep.label;

    switch(label) {
      case "stepProcedimento":
        this.steps.procedimento.completed = true;
        break;
      case "stepHorario":
        this.steps.horario.completed = true;
        break;
      case "stepConvenio":
        this.steps.convenio.completed = true;
        break;
      case "stepPagamento":
        this.steps.pagamento.completed = true;
        break;
      case "stepResumo":
        this.steps.resumo.completed = true;
        break;
      case "stepConvenio":
        this.steps.convenio.completed = true;
        break;
      default:
        break;
    }
  });

  getUserData() {
    const userData = sessionStorage.getItem('userData');
  
    this.sessionData = {
      userData: JSON.parse(userData),
    };
  }
}
